export default __webpack_public_path__ + "static/media/plusCircle.3d9b94e0.svg";